import axios from "axios";

// Always use same-origin for API calls unless we're on the exact preview domain
const ENV_URL = process.env.REACT_APP_BACKEND_URL || "";
const envHostname = (() => { try { return new URL(ENV_URL).hostname; } catch { return ""; } })();
const BACKEND_URL = (envHostname && envHostname === window.location.hostname)
  ? ENV_URL
  : window.location.origin;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { "Content-Type": "application/json" },
});

// Attach session token from localStorage as Bearer header on every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On login/register/session responses, persist the session token
api.interceptors.response.use(
  (response) => {
    if (response.data?.session_token) {
      localStorage.setItem("session_token", response.data.session_token);
    }
    return response;
  },
  (error) => {
    // If 401, clear stale token
    if (error.response?.status === 401) {
      localStorage.removeItem("session_token");
    }
    return Promise.reject(error);
  }
);

export default api;
